import Link from 'next/link'
import Image from 'next/image'

import Text from '~/components/Text'

const CustomImage = (props) => {
  return (
    <div className="w-screen relative left-1/2 right-1/2 -ml-halfscreen -mr-half-screen py-8 mg:py-18">
      <div className="max-w-7xl mx-auto w-full lg:px-6">
        <Image
          src={props.src}
          width="100%"
          height="56.25%"
          layout="responsive"
          objectFit="cover"
          className="relative z-10"
          {...props}
        />
      </div>
    </div>
  )
}

const CustomLink = (props) => {
  const href = props.href
  const isInternalLink = href?.startsWith('/') || href?.startsWith('#')

  if (isInternalLink) {
    return (
      <Link href={href}>
        <a {...props} />
      </Link>
    )
  }

  return <a target="_blank" rel="noopener noreferrer" {...props} />
}

const MDXComponents = {
  a: CustomLink,
  p: Text,
  img: CustomImage
}

export default MDXComponents
